var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginDefaultImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 720 800",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_5646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M753.885 81.8554L706.754 54.237L753.885 26.6185V81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 54.237V-1L753.885 26.6185L706.754 54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 -1H753.885V26.6185L706.754 -1Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 26.6185L612.524 -1V54.237L565.41 26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 81.8554L518.295 54.237L565.41 26.6185V81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 -1H612.524L565.41 26.6185V-1Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 26.6185L612.524 54.237L565.41 81.8554V26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 54.237V-1L565.41 26.6185L518.295 54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 -1H565.41V26.6185L518.295 -1Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 26.6185L706.754 -1V54.237L659.639 26.6185Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 81.8554L612.525 54.237L659.639 26.6185V81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 -1H706.754L659.639 26.6185V-1Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 26.6185L706.754 54.237L659.639 81.8554V26.6185Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 54.237V-1L659.639 26.6185L612.525 54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 -1H659.639V26.6185L612.525 -1Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 26.6185L424.049 54.237V-1L471.18 26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 -1H518.295L471.18 26.6185V-1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 81.8554L424.049 54.237L471.18 26.6185V81.8554Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 26.6185L424.049 -1H471.18V26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 -1V54.237L471.18 26.6185L518.295 -1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 54.237L471.18 81.8554V26.6185L518.295 54.237Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 26.6185L329.82 -1V54.237L282.705 26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 81.8554L235.59 54.237L282.705 26.6185V81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 -1H329.82L282.705 26.6185V-1Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 26.6185L329.82 54.237L282.705 81.8554V26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 54.237V-1L282.705 26.6185L235.59 54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 -1H282.705V26.6185L235.59 -1Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 26.6185L329.82 54.237V-1L376.935 26.6185Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 -1H424.049L376.935 26.6185V-1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 81.8554L329.82 54.237L376.935 26.6185V81.8554Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 26.6185L329.82 -1H376.935V26.6185Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 -1V54.237L376.935 26.6185L424.049 -1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 54.237L376.935 81.8554V26.6185L424.049 54.237Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 26.6185L141.344 54.237V-1L188.475 26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 -1H235.59L188.475 26.6185V-1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 81.8554L141.344 54.237L188.475 26.6185V81.8554Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 26.6185L141.344 -1H188.475V26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 -1V54.237L188.475 26.6185L235.59 -1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 54.237L188.475 81.8554V26.6185L235.59 54.237Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.6185L47.1148 -1V54.237L0 26.6185Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -1H47.1148L0 26.6185V-1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.6185L47.1148 54.237L0 81.8554V26.6185Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 26.6185L47.1149 54.237V-1L94.2297 26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 -1H141.345L94.2297 26.6185V-1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 81.8554L47.1149 54.237L94.2297 26.6185V81.8554Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 26.6185L47.1149 -1H94.2297V26.6185Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 -1V54.237L94.2297 26.6185L141.345 -1Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 54.237L94.2297 81.8554V26.6185L141.345 54.237Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 109.474L565.41 137.108V81.8554L612.525 109.474Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 54.237L659.639 81.8554L612.525 109.474V54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 164.727L565.41 137.108L612.525 109.49V164.727Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 109.474L565.41 81.8554L612.525 54.237V109.474Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 81.8554V137.108L612.525 109.474L659.639 81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 137.108L612.525 164.727V109.49L659.639 137.108Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 109.474L753.885 81.8554V137.108L706.754 109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 164.727L659.64 137.108L706.754 109.474V164.727Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 54.237L753.885 81.8554L706.754 109.474V54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 109.474L753.885 137.108L706.754 164.727V109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.64 137.108V81.8554L706.754 109.474L659.64 137.108Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.64 81.8554L706.754 54.237V109.474L659.64 81.8554Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 109.474L471.18 137.108V81.8554L518.295 109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 54.237L565.41 81.8554L518.295 109.474V54.237Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 164.727L471.18 137.108L518.295 109.49V164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 109.474L471.18 81.8554L518.295 54.237V109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 81.8554V137.108L518.295 109.474L565.41 81.8554Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 137.108L518.295 164.727V109.49L565.41 137.108Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 109.474L282.705 137.108V81.8554L329.82 109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 54.237L376.935 81.8554L329.82 109.474V54.237Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 164.727L282.705 137.108L329.82 109.49V164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 109.474L282.705 81.8554L329.82 54.237V109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 81.8554V137.108L329.82 109.474L376.935 81.8554Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 137.108L329.82 164.727V109.49L376.935 137.108Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 109.474L376.935 137.108V81.8554L424.065 109.474Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 54.237L471.18 81.8554L424.065 109.474V54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 164.727L376.935 137.108L424.065 109.49V164.727Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 109.474L376.935 81.8554L424.065 54.237V109.474Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 81.8554V137.108L424.065 109.474L471.18 81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 137.108L424.065 164.727V109.49L471.18 137.108Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 109.474L188.475 137.108V81.8554L235.59 109.474Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 54.237L282.705 81.8554L235.59 109.474V54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 164.727L188.475 137.108L235.59 109.49V164.727Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 109.474L188.475 81.8554L235.59 54.237V109.474Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 81.8554V137.108L235.59 109.474L282.705 81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 137.108L235.59 164.727V109.49L282.705 137.108Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 109.474L0 137.108V81.8554L47.1148 109.474Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 54.237L94.2297 81.8554L47.1149 109.474V54.237Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 164.727L0 137.108L47.1148 109.49V164.727Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 109.474L0 81.8554L47.1148 54.237V109.474Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 81.8554V137.108L47.1149 109.474L94.2297 81.8554Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 137.108L47.1149 164.727V109.49L94.2297 137.108Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 109.474L94.2296 137.108V81.8554L141.36 109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 54.237L188.475 81.8554L141.36 109.474V54.237Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 164.727L94.2296 137.108L141.36 109.49V164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 109.474L94.2296 81.8554L141.36 54.237V109.474Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 81.8554V137.108L141.36 109.474L188.475 81.8554Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 137.108L141.36 164.727V109.49L188.475 137.108Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 192.345L706.754 219.964V164.727L753.885 192.345Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 247.582L706.754 219.964L753.885 192.345V247.582Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 192.345L706.754 164.727L753.885 137.108V192.345Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 192.345L518.295 219.964V164.727L565.41 192.345Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 137.108L612.524 164.727L565.41 192.345V137.108Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 247.582L518.295 219.964L565.41 192.345V247.582Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 192.345L518.295 164.727L565.41 137.108V192.345Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.524 164.727V219.964L565.41 192.345L612.524 164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.524 219.964L565.41 247.582V192.345L612.524 219.964Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 192.345L612.525 219.964V164.727L659.639 192.345Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 137.108L706.754 164.727L659.639 192.345V137.108Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 247.582L612.525 219.964L659.639 192.345V247.582Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 192.345L612.525 164.727L659.639 137.108V192.345Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 164.727V219.964L659.639 192.345L706.754 164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 219.964L659.639 247.582V192.345L706.754 219.964Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 192.345L424.049 219.964V164.727L471.18 192.345Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 137.108L518.295 164.727L471.18 192.345V137.108Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 247.582L424.049 219.964L471.18 192.345V247.582Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 192.345L424.049 164.727L471.18 137.108V192.345Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 164.727V219.964L471.18 192.345L518.295 164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 219.964L471.18 247.582V192.345L518.295 219.964Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 192.345L329.82 164.727V219.964L282.705 192.345Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 247.582L235.59 219.964L282.705 192.345V247.582Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 137.108L329.82 164.727L282.705 192.345V137.108Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 192.345L329.82 219.964L282.705 247.582V192.345Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 219.964V164.727L282.705 192.345L235.59 219.964Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 164.727L282.705 137.108V192.345L235.59 164.727Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 192.345L329.82 219.964V164.727L376.935 192.345Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 137.108L424.049 164.727L376.935 192.345V137.108Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 247.582L329.82 219.964L376.935 192.345V247.582Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 192.345L329.82 164.727L376.935 137.108V192.345Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 164.727V219.964L376.935 192.345L424.049 164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 219.964L376.935 247.582V192.345L424.049 219.964Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 192.345L141.344 219.964V164.727L188.475 192.345Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 137.108L235.59 164.727L188.475 192.345V137.108Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 247.582L141.344 219.964L188.475 192.345V247.582Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 192.345L141.344 164.727L188.475 137.108V192.345Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 164.727V219.964L188.475 192.345L235.59 164.727Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 219.964L188.475 247.582V192.345L235.59 219.964Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 137.108L47.1148 164.727L0 192.345V137.108Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 164.727V219.964L0 192.345L47.1148 164.727Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 219.964L0 247.582V192.345L47.1148 219.964Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 192.345L47.1149 219.964V164.727L94.2297 192.345Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 137.108L141.345 164.727L94.2297 192.345V137.108Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 247.582L47.1149 219.964L94.2297 192.345V247.582Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 192.345L47.1149 164.727L94.2297 137.108V192.345Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 164.727V219.964L94.2297 192.345L141.345 164.727Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 219.964L94.2297 247.582V192.345L141.345 219.964Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 275.201L659.639 247.582V302.819L612.525 275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 330.454L565.41 302.819L612.525 275.201V330.454Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 219.964L659.639 247.582L612.525 275.201V219.964Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 275.201L659.639 302.819L612.525 330.454V275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 302.819V247.582L612.525 275.201L565.41 302.819Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 247.582L612.525 219.964V275.201L565.41 247.582Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 275.201L659.64 302.819V247.582L706.754 275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 219.964L753.885 247.582L706.754 275.201V219.964Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 330.454L659.64 302.835L706.754 275.201V330.454Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 275.201L659.64 247.582L706.754 219.964V275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 247.582V302.819L706.754 275.201L753.885 247.582Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 302.819V302.835L706.754 330.454V275.201L753.885 302.819Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 275.201L471.18 302.819V247.582L518.295 275.201Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 219.964L565.41 247.582L518.295 275.201V219.964Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 330.454L471.18 302.835L518.295 275.201V330.454Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 275.201L471.18 247.582L518.295 219.964V275.201Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 247.582V302.819L518.295 275.201L565.41 247.582Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 302.819V302.835L518.295 330.454V275.201L565.41 302.819Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 275.201L282.705 302.819V247.582L329.82 275.201Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 219.964L376.935 247.582L329.82 275.201V219.964Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 330.454L282.705 302.835L329.82 275.201V330.454Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 275.201L282.705 247.582L329.82 219.964V275.201Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 247.582V302.819L329.82 275.201L376.935 247.582Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 302.819V302.835L329.82 330.454V275.201L376.935 302.819Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 275.201L471.18 247.582V302.819L424.065 275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 330.454L376.935 302.819L424.065 275.201V330.454Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 219.964L471.18 247.582L424.065 275.201V219.964Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 275.201L471.18 302.819L424.065 330.454V275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 302.819V247.582L424.065 275.201L376.935 302.819Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 247.582L424.065 219.964V275.201L376.935 247.582Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 275.201L282.705 247.582V302.819L235.59 275.201Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 330.454L188.475 302.819L235.59 275.201V330.454Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 219.964L282.705 247.582L235.59 275.201V219.964Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 275.201L282.705 302.819L235.59 330.454V275.201Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 302.819V247.582L235.59 275.201L188.475 302.819Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 247.582L235.59 219.964V275.201L188.475 247.582Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 275.201L0 302.819V247.582L47.1148 275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 219.964L94.2297 247.582L47.1149 275.201V219.964Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 330.454L0 302.835L47.1148 275.201V330.454Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 275.201L0 247.582L47.1148 219.964V275.201Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 247.582V302.819L47.1149 275.201L94.2297 247.582Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 302.819V302.835L47.1149 330.454V275.201L94.2297 302.819Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 275.201L94.2296 302.819V247.582L141.36 275.201Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 219.964L188.475 247.582L141.36 275.201V219.964Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 330.454L94.2296 302.835L141.36 275.201V330.454Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 275.201L94.2296 247.582L141.36 219.964V275.201Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 247.582V302.819L141.36 275.201L188.475 247.582Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 302.819V302.835L141.36 330.454V275.201L188.475 302.819Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 413.309L706.754 385.691L753.885 358.072V413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 385.691V330.454L753.885 358.072L706.754 385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 330.454L753.885 302.835V358.072L706.754 330.454Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 358.072L612.524 330.454V385.691L565.41 358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 413.309L518.295 385.691L565.41 358.072V413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 302.835L612.524 330.454L565.41 358.072V302.835Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 358.072L612.524 385.691L565.41 413.309V358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 385.691V330.454L565.41 358.072L518.295 385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 330.454L565.41 302.835V358.072L518.295 330.454Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 358.072L706.754 330.454V385.691L659.639 358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 413.309L612.525 385.691L659.639 358.072V413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 302.835L706.754 330.454L659.639 358.072V302.835Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 358.072L706.754 385.691L659.639 413.309V358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 385.691V330.454L659.639 358.072L612.525 385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 330.454L659.639 302.835V358.072L612.525 330.454Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 358.072L518.295 330.454V385.691L471.18 358.072Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 413.309L424.049 385.691L471.18 358.072V413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 302.835L518.295 330.454L471.18 358.072V302.835Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 358.072L518.295 385.691L471.18 413.309V358.072Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 385.691V330.454L471.18 358.072L424.049 385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 330.454L471.18 302.835V358.072L424.049 330.454Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 358.072L235.59 385.691V330.454L282.705 358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 302.819L329.82 330.454L282.705 358.072V302.819Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 413.309L235.59 385.691L282.705 358.072V413.309Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 358.072L235.59 330.454L282.705 302.819V358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 330.454V385.691L282.705 358.072L329.82 330.454Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 385.691L282.705 413.309V358.072L329.82 385.691Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 358.072L329.82 385.691V330.454L376.935 358.072Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 302.819L424.049 330.454L376.935 358.072V302.819Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 413.309L329.82 385.691L376.935 358.072V413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 358.072L329.82 330.454L376.935 302.819V358.072Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 330.454V385.691L376.935 358.072L424.049 330.454Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 385.691L376.935 413.309V358.072L424.049 385.691Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 358.072L141.344 385.691V330.454L188.475 358.072Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 302.819L235.59 330.454L188.475 358.072V302.819Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 413.309L141.344 385.691L188.475 358.072V413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 358.072L141.344 330.454L188.475 302.819V358.072Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 330.454V385.691L188.475 358.072L235.59 330.454Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 385.691L188.475 413.309V358.072L235.59 385.691Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 358.072L47.1148 330.454V385.691L0 358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 302.835L47.1148 330.454L0 358.072V302.835Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 358.072L47.1148 385.691L0 413.309V358.072Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 358.072L141.345 330.454V385.691L94.2297 358.072Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 413.309L47.1149 385.691L94.2297 358.072V413.309Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 302.835L141.345 330.454L94.2297 358.072V302.835Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 358.072L141.345 385.691L94.2297 413.309V358.072Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 385.691V330.454L94.2297 358.072L47.1149 385.691Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 330.454L94.2297 302.835V358.072L47.1149 330.454Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 440.928L659.639 413.309V468.546L612.525 440.928Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 496.165L565.41 468.546L612.525 440.928V496.165Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 385.691L659.639 413.309L612.525 440.928V385.691Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 440.928L659.639 468.546L612.525 496.165V440.928Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 468.546V413.309L612.525 440.928L565.41 468.546Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 413.309L612.525 385.691V440.928L565.41 413.309Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 440.928L659.64 468.546V413.309L706.754 440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 385.691L753.885 413.309L706.754 440.928V385.691Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 496.165L659.64 468.546L706.754 440.928V496.165Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 440.928L659.64 413.309L706.754 385.691V440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 413.309V468.546L706.754 440.928L753.885 413.309Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 468.546L706.754 496.165V440.928L753.885 468.546Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 440.928L565.41 413.309V468.546L518.295 440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 496.165L471.18 468.546L518.295 440.928V496.165Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 385.691L565.41 413.309L518.295 440.928V385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 440.928L565.41 468.546L518.295 496.165V440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 468.546V413.309L518.295 440.928L471.18 468.546Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 413.309L518.295 385.691V440.928L471.18 413.309Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 440.928L282.705 468.546V413.309L329.82 440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 385.691L376.935 413.309L329.82 440.928V385.691Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 496.165L282.705 468.546L329.82 440.928V496.165Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 440.928L282.705 413.309L329.82 385.691V440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 413.309V468.546L329.82 440.928L376.935 413.309Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 468.546L329.82 496.165V440.928L376.935 468.546Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 440.928L471.18 413.309V468.546L424.065 440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 496.165L376.935 468.546L424.065 440.928V496.165Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 385.691L471.18 413.309L424.065 440.928V385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 440.928L471.18 468.546L424.065 496.165V440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 468.546V413.309L424.065 440.928L376.935 468.546Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 413.309L424.065 385.691V440.928L376.935 413.309Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 440.928L188.475 468.546V413.309L235.59 440.928Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 385.691L282.705 413.309L235.59 440.928V385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 496.165L188.475 468.546L235.59 440.928V496.165Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 440.928L188.475 413.309L235.59 385.691V440.928Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 413.309V468.546L235.59 440.928L282.705 413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 468.546L235.59 496.165V440.928L282.705 468.546Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 440.928L0 468.546V413.309L47.1148 440.928Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 385.691L94.2297 413.309L47.1149 440.928V385.691Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 496.165L0 468.546L47.1148 440.928V496.165Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 440.928L0 413.309L47.1148 385.691V440.928Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 413.309V468.546L47.1149 440.928L94.2297 413.309Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 468.546L47.1149 496.165V440.928L94.2297 468.546Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 440.928L94.2296 468.546V413.309L141.36 440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 385.691L188.475 413.309L141.36 440.928V385.691Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 496.165L94.2296 468.546L141.36 440.928V496.165Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 440.928L94.2296 413.309L141.36 385.691V440.928Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 413.309V468.546L141.36 440.928L188.475 413.309Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 468.546L141.36 496.165V440.928L188.475 468.546Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 579.036L706.754 551.418L753.885 523.799V579.036Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 551.418V496.165L753.885 523.799L706.754 551.418Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 496.165L753.885 468.546V523.799L706.754 496.165Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 523.783L518.295 551.418V496.165L565.41 523.783Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 468.546L612.524 496.165L565.41 523.783V468.546Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 579.036L518.295 551.418L565.41 523.799V579.036Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 523.783L518.295 496.165L565.41 468.546V523.783Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.524 496.165V551.418L565.41 523.783L612.524 496.165Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.524 551.418L565.41 579.036V523.799L612.524 551.418Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 523.799L706.754 496.165V551.418L659.639 523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 579.036L612.525 551.418L659.639 523.799V579.036Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 468.546L706.754 496.165L659.639 523.799V468.546Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 523.799L706.754 551.418L659.639 579.036V523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 551.418V496.165L659.639 523.799L612.525 551.418Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 496.165L659.639 468.546V523.799L612.525 496.165Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 523.799L518.295 496.165V551.418L471.18 523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 579.036L424.049 551.418L471.18 523.799V579.036Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 468.546L518.295 496.165L471.18 523.799V468.546Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 523.799L518.295 551.418L471.18 579.036V523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 551.418V496.165L471.18 523.799L424.049 551.418Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 496.165L471.18 468.546V523.799L424.049 496.165Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 523.799L329.82 496.165V551.418L282.705 523.799Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 579.036L235.59 551.418L282.705 523.799V579.036Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 468.546L329.82 496.165L282.705 523.799V468.546Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 523.799L329.82 551.418L282.705 579.036V523.799Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 551.418V496.165L282.705 523.799L235.59 551.418Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 496.165L282.705 468.546V523.799L235.59 496.165Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 523.799L424.049 496.165V551.418L376.935 523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 579.036L329.82 551.418L376.935 523.799V579.036Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 468.546L424.049 496.165L376.935 523.799V468.546Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 523.799L424.049 551.418L376.935 579.036V523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 551.418V496.165L376.935 523.799L329.82 551.418Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 496.165L376.935 468.546V523.799L329.82 496.165Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 523.783L141.344 551.418V496.165L188.475 523.783Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 468.546L235.59 496.165L188.475 523.783V468.546Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 579.036L141.344 551.418L188.475 523.799V579.036Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 523.783L141.344 496.165L188.475 468.546V523.783Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 496.165V551.418L188.475 523.783L235.59 496.165Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 551.418L188.475 579.036V523.799L235.59 551.418Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 523.799L47.1148 496.165V551.418L0 523.799Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 468.546L47.1148 496.165L0 523.799V468.546Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 523.799L47.1148 551.418L0 579.036V523.799Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 523.799L141.345 496.165V551.418L94.2297 523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 579.036L47.1149 551.418L94.2297 523.799V579.036Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 468.546L141.345 496.165L94.2297 523.799V468.546Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 523.799L141.345 551.418L94.2297 579.036V523.799Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 551.418V496.165L94.2297 523.799L47.1149 551.418Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 496.165L94.2297 468.546V523.799L47.1149 496.165Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 606.655L659.639 579.036V634.273L612.525 606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 661.892L565.41 634.273L612.525 606.655V661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 551.418L659.639 579.036L612.525 606.655V551.418Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 606.655L659.639 634.273L612.525 661.892V606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 634.273V579.036L612.525 606.655L565.41 634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 579.036L612.525 551.418V606.655L565.41 579.036Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 606.655L659.64 634.273V579.036L706.754 606.655Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 551.418L753.885 579.036L706.754 606.655V551.418Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 661.892L659.64 634.273L706.754 606.655V661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 606.655L659.64 579.036L706.754 551.418V606.655Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 579.036V634.273L706.754 606.655L753.885 579.036Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 634.273L706.754 661.892V606.655L753.885 634.273Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 606.655L565.41 579.036V634.273L518.295 606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 661.892L471.18 634.273L518.295 606.655V661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 551.418L565.41 579.036L518.295 606.655V551.418Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 606.655L565.41 634.273L518.295 661.892V606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 634.273V579.036L518.295 606.655L471.18 634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 579.036L518.295 551.418V606.655L471.18 579.036Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 606.655L376.935 579.036V634.273L329.82 606.655Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 661.892L282.705 634.273L329.82 606.655V661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 551.418L376.935 579.036L329.82 606.655V551.418Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 606.655L376.935 634.273L329.82 661.892V606.655Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 634.273V579.036L329.82 606.655L282.705 634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 579.036L329.82 551.418V606.655L282.705 579.036Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 606.655L376.935 634.273V579.036L424.065 606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 551.418L471.18 579.036L424.065 606.655V551.418Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 661.892L376.935 634.273L424.065 606.655V661.892Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 606.655L376.935 579.036L424.065 551.418V606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 579.036V634.273L424.065 606.655L471.18 579.036Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 634.273L424.065 661.892V606.655L471.18 634.273Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 606.655L282.705 579.036V634.273L235.59 606.655Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 661.892L188.475 634.273L235.59 606.655V661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 551.418L282.705 579.036L235.59 606.655V551.418Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 606.655L282.705 634.273L235.59 661.892V606.655Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 634.273V579.036L235.59 606.655L188.475 634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 579.036L235.59 551.418V606.655L188.475 579.036Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 606.655L94.2297 579.036V634.273L47.1149 606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 661.892L0 634.273L47.1148 606.655V661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 551.418L94.2297 579.036L47.1149 606.655V551.418Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 606.655L94.2297 634.273L47.1149 661.892V606.655Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 634.273V579.036L47.1148 606.655L0 634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 579.036L47.1148 551.418V606.655L0 579.036Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 606.655L188.475 579.036V634.273L141.36 606.655Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 661.892L94.2296 634.273L141.36 606.655V661.892Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 551.418L188.475 579.036L141.36 606.655V551.418Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 606.655L188.475 634.273L141.36 661.892V606.655Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2296 634.273V579.036L141.36 606.655L94.2296 634.273Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2296 579.036L141.36 551.418V606.655L94.2296 579.036Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 689.51L706.754 717.129V661.892L753.885 689.51Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 744.763L706.754 717.145L753.885 689.51V744.763Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.885 689.51L706.754 661.892L753.885 634.273V689.51Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 689.51L612.524 661.892V717.129L565.41 689.51Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 744.763L518.295 717.129L565.41 689.51V744.763Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 634.273L612.524 661.892L565.41 689.51V634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.41 689.51L612.524 717.129L565.41 744.763V689.51Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 717.129V661.892L565.41 689.51L518.295 717.129Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 661.892L565.41 634.273V689.51L518.295 661.892Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 689.51L612.525 717.129V661.892L659.639 689.51Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 634.273L706.754 661.892L659.639 689.51V634.273Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 744.763L612.525 717.129L659.639 689.51V744.763Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 689.51L612.525 661.892L659.639 634.273V689.51Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 661.892V717.129L659.639 689.51L706.754 661.892Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 717.129L659.639 744.763V689.51L706.754 717.129Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 689.51L424.049 717.129V661.892L471.18 689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 634.273L518.295 661.892L471.18 689.51V634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 744.763L424.049 717.129L471.18 689.51V744.763Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 689.51L424.049 661.892L471.18 634.273V689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 661.892V717.129L471.18 689.51L518.295 661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 717.129L471.18 744.763V689.51L518.295 717.129Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 689.51L329.82 661.892V717.129L282.705 689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 744.763L235.59 717.129L282.705 689.51V744.763Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 634.273L329.82 661.892L282.705 689.51V634.273Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.705 689.51L329.82 717.129L282.705 744.763V689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 717.129V661.892L282.705 689.51L235.59 717.129Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 661.892L282.705 634.273V689.51L235.59 661.892Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 689.51L329.82 717.129V661.892L376.935 689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 634.273L424.049 661.892L376.935 689.51V634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 744.763L329.82 717.129L376.935 689.51V744.763Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 689.51L329.82 661.892L376.935 634.273V689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 661.892V717.129L376.935 689.51L424.049 661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.049 717.129L376.935 744.763V689.51L424.049 717.129Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 689.51L141.344 717.129V661.892L188.475 689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 634.273L235.59 661.892L188.475 689.51V634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 744.763L141.344 717.145L188.475 689.51V744.763Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 689.51L141.344 661.892L188.475 634.273V689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 661.892V717.129L188.475 689.51L235.59 661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 717.129V717.145L188.475 744.763V689.51L235.59 717.129Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 634.273L47.1148 661.892L0 689.51V634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 661.892V717.129L0 689.51L47.1148 661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 717.129L0 744.763V689.51L47.1148 717.129Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 689.51L47.1149 717.129V661.892L94.2297 689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 634.273L141.345 661.892L94.2297 689.51V634.273Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 744.763L47.1149 717.145L94.2297 689.51V744.763Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 689.51L47.1149 661.892L94.2297 634.273V689.51Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 661.892V717.129L94.2297 689.51L141.345 661.892Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.345 717.129V717.145L94.2297 744.763V689.51L141.345 717.129Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 772.382L565.41 800V744.763L612.525 772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 717.129L659.639 744.763L612.525 772.382V717.129Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 800H565.41L612.525 772.382V800Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.525 772.382L565.41 744.763L612.525 717.129V772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 744.763V800L612.525 772.382L659.639 744.763Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.639 800H612.525V772.382L659.639 800Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 772.382L753.885 744.763V800L706.754 772.382Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 800H659.64L706.754 772.382V800Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 717.129L753.885 744.763L706.754 772.382V717.129Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.754 772.382L753.885 800H706.754V772.382Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.64 800V744.763L706.754 772.382L659.64 800Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.64 744.763L706.754 717.129V772.382L659.64 744.763Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 772.382L565.41 744.763V800L518.295 772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 800H471.18L518.295 772.382V800Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 717.145L565.41 744.763L518.295 772.382V717.145Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.295 772.382L565.41 800H518.295V772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 800V744.763L518.295 772.382L471.18 800Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 744.763L518.295 717.145V772.382L471.18 744.763Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 772.382L282.705 800V744.763L329.82 772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 717.129L376.935 744.763L329.82 772.382V717.129Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 800H282.705L329.82 772.382V800Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82 772.382L282.705 744.763L329.82 717.129V772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 744.763V800L329.82 772.382L376.935 744.763Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.935 800H329.82V772.382L376.935 800Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 772.382L376.935 800V744.763L424.065 772.382Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 717.129L471.18 744.763L424.065 772.382V717.129Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 800H376.935L424.065 772.382V800Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.065 772.382L376.935 744.763L424.065 717.129V772.382Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 744.763V800L424.065 772.382L471.18 744.763Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.18 800H424.065V772.382L471.18 800Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 772.382L282.705 744.763V800L235.59 772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 800H188.475L235.59 772.382V800Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 717.145L282.705 744.763L235.59 772.382V717.145Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.59 772.382L282.705 800H235.59V772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 800V744.763L235.59 772.382L188.475 800Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 744.763L235.59 717.145V772.382L188.475 744.763Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 772.382L0 800V744.763L47.1148 772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1149 717.129L94.2297 744.763L47.1149 772.382V717.129Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 800H0L47.1148 772.382V800Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1148 772.382L0 744.763L47.1148 717.129V772.382Z",
    fill: "#4099DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 744.763V800L47.1149 772.382L94.2297 744.763Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2297 800H47.1149V772.382L94.2297 800Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 772.382L94.2296 800V744.763L141.36 772.382Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 717.129L188.475 744.763L141.36 772.382V717.129Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 800H94.2296L141.36 772.382V800Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.36 772.382L94.2296 744.763L141.36 717.129V772.382Z",
    fill: "#E3E3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 744.763V800L141.36 772.382L188.475 744.763Z",
    fill: "#1F4973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.475 800H141.36V772.382L188.475 800Z",
    fill: "#4099DB"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 800,
    width: "100%",
    height: "100%",
    transform: "rotate(-180 720 800)",
    fill: "url(#paint0_linear_185_5646)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_5646",
    x1: 1080,
    y1: 800,
    x2: 1080,
    y2: 1600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_5646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white",
    transform: "translate(0 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDefaultImage);
export default __webpack_public_path__ + "static/media/loginDefaultImage.9cff694e9178e759b254a703d49ee8e8.svg";
export { ForwardRef as ReactComponent };